import React from 'react';

const SubFlowNameInput = ({ onChange, value }) => (
    <div className="form-group">
        <label>
            { 'Name' }
            <span className="input-required"> *</span>
        </label>
        <input
            value={value}
            onChange={onChange}
            maxLength="255"
            size="25"
            required
            className="form-control"
            type="text"
        />
    </div>
);

export default SubFlowNameInput;
